import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";
import "./DateFilter.css";

import calendar from "../../images/icons/filterCalender.png";
import close from "../../images/icons/close.png";

const DateFilter = ({ setFilterDate }) => {
  const [selectDate, setSelectDate] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleChange = (date) => {
    const dateString = date ? format(date, "yyyy-MM-dd") : null;
    console.log(dateString);
    setFilterDate(dateString);
    setIsCalendarOpen(!isCalendarOpen);
    setSelectDate(date);
  };

  const handleClearChange = () => {
    setFilterDate(null);
    setIsCalendarOpen(!isCalendarOpen);
    setSelectDate(null);
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setIsCalendarOpen(!isCalendarOpen);
    }
  };
  const imgHandleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (selectDate) {
        handleClearChange();
      }
    }
  };
  return (
    <div className="date-container">
      <DatePicker
        open={isCalendarOpen}
        placeholderText="Select Date"
        selected={selectDate}
        onChange={handleChange}
        dateFormat="yyyy-MM-dd"
        className="custom-datepicker"
      />
      <div
        className="date-pic-container"
        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
        onKeyDown={handleKeyDown}
      >
        {selectDate ? (
          <img
            src={close}
            alt="close"
            className="close"
            onClick={handleClearChange} 
            onKeyDown={imgHandleKeyDown}
            />
        ) : (
          <img
            src={calendar}
            alt="calendar"
            className="calendar" 
            onKeyDown={imgHandleKeyDown}

            />
        )}
      </div>
    </div>
  );
};

export default DateFilter;
